import { Component, Input, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: '[sg-blockable]',
  host: {
    '[style.position]': `'relative'`,
    '[style.minHeight]': `_hostMinHeight`,
  },
  templateUrl: './blockable.component.html',
  styleUrls: ['./blockable.component.scss'],
  encapsulation: ViewEncapsulation.None,
  exportAs: 'sgBlockable',
  standalone: false,
})
export class SgBlockableComponent {
  @Input('sg-blockable') get blocked(): boolean {
    return this._blocked;
  }
  set blocked(value: boolean) {
    if (value !== this._blocked) {
      this._blocked = value;
      this.updateHostHeight();
    }
  }
  _blocked = false;

  @Input() get blockMessage(): string {
    return this._blockMessage;
  }
  set blockMessage(value: string) {
    if (value !== this._blockMessage) {
      this._blockMessage = value;
    }
  }
  _blockMessage = '';

  get blockerStyle(): 'spinner' | 'progressBar' {
    return this._blockerStyle;
  }
  @Input() set blockerStyle(value: 'spinner' | 'progressBar') {
    if (value !== this._blockerStyle) {
      this._blockerStyle = value;
    }
  }
  _blockerStyle: 'spinner' | 'progressBar' = 'spinner';

  get blockerStyleDirection(): 'start' | 'center' | 'end' {
    return this._blockerDirection;
  }

  @Input() set blockerStyleDirection(value: 'start' | 'center' | 'end') {
    if (value !== this._blockerDirection) {
      this._blockerDirection = value;
    }
  }
  _blockerDirection: 'start' | 'center' | 'end' = 'center';

  @Input() hostMinHeight: string;

  _hostMinHeight: string | null;

  @Input() set overlayColor(value: string) {
    if (value) {
      this._overlayColor = value;
    }
  }

  _overlayColor = null;

  constructor(private cdr: ChangeDetectorRef) {}

  block(): void {
    this.blocked = true;
  }

  unblock(): void {
    this.blocked = false;
  }

  private updateHostHeight(): void {
    if (this.hostMinHeight === '') {
      this._hostMinHeight = null;
    } else {
      this.hostMinHeight = this._blocked ? this.hostMinHeight : null;
    }
  }
}
